import Vue from "vue";
import VueRouter from "vue-router";
import { isLogin, openLogin } from "@/assets/js/utils";
import { service_const } from "@/assets/js/consts";

Vue.use(VueRouter);

//主页框架
import Main from "@/views/main";

let routes = [
  {
    path: "/",
    name: "main",
    component: Main,
    meta: {
      is_login: true,
    },
    children: [],
  },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

let initRouter = false;

router.beforeEach((to, from, next) => {
  if (!initRouter) {
    initRouter = true;
    routerGo(to, next);
    return false;
  }
  let login = to.meta.is_login;
  if (login == false) {
    next(true);
  } else {
    if (isLogin()) {
      next(true);
    } else {
      console.log("需要登陆，跳转中...");
      openLogin();
    }
  }
});

router.afterEach((to, form) => {
  setTimeout(() => {
    let forms = document.getElementsByClassName("el-form");
    for (var i = 0; i < forms.length; i++) {
      let el = forms[i].getElementsByClassName("el-button--primary");
      if (el && el[0]) {
        el[0].type = "submit";
      }
      forms[i].onsubmit = function () {
        return false;
      };
    }
    let navs = document.getElementsByClassName("list-nav");
    for (var j = 0; j < navs.length; j++) {
      let key = window.location.href + "_nav" + j;
      let nav = navs[j];
      if (nav.className.indexOf("none-nav") > -1) {
        continue;
      }
      let childNodes = nav.getElementsByTagName("li");
      for (var i = 0; i < childNodes.length; i++) {
        let childNode = childNodes[i];
        childNode.setAttribute("index", i);
        childNode.onclick = function () {
          let index = this.getAttribute("index");
          console.log(index);
          _global_.cacheData.set(key, index);
          for (var c = 0; c < childNodes.length; c++) {
            if (c != index) {
              childNodes[c].className = "";
            }
            if (c == index) {
              childNodes[c].className = "active";
            }
          }
        };
        let sel = _global_.cacheData.get(key);
        if (sel && sel == i) {
          for (var c = 0; c < childNodes.length; c++) {
            childNodes[c].className = "";
          }
          childNode.className = "active";
        }
      }
    }
  }, 500);
});

function routerGo(to, next) {
  //系统初始化
  // api('system.application.info').then(res => {
  //   console.log('1111111111111111111')
  //   _global_.UI = res.data
  //   Vue.prototype.GLOBAL = _global_
  //   console.log(_global_.UI)
  // })
  let arr = [];
  arr = window.location.href.split("?");
  let fix = arr[1];
  api("system.application.info", {
    domain_postfix: fix,
  }).then((res) => {
    _global_.UI = res.data;
    console.log(_global_.UI);
    Vue.prototype.GLOBAL = _global_;
  });
  api("system.app.router").then((res) => {
    res.data.forEach((sub) => {
      let parent_menu = getParentMenu(res.data, sub.menu_code);
      let parent_menu_name = parent_menu == null ? "" : parent_menu.menu_name;
      //添加菜单路由
      if (sub.menu_url) {
        let modul = createModul(
          sub.menu_url,
          sub.is_login,
          sub.menu_code,
          parent_menu_name + " > " + sub.menu_name,
          sub.is_refresh
        );
        routes[0].children.push(modul);
      }
      //添加功能路由
      if (sub.options) {
        let options = JSON.parse(sub.options);
        options.forEach((option) => {
          let modul = createModul(
            option.path,
            false,
            option.code,
            parent_menu_name + " > " + sub.menu_name + " > " + option.name,
            option.is_refresh
          );
          if (sub.is_login) {
            routes[0].children.push(modul);
          } else {
            routes.push(modul);
          }
        });
      }
    });
    router.addRoutes(routes);
    next({
      ...to,
      replace: true,
    });
  });
}

function getParentMenu(data, menu_code) {
  return data.find((item) => {
    if (item.menu_code.indexOf("_") == -1) {
      return menu_code.indexOf(item.menu_code) == 0;
    }
  });
}

function createModul(path, is_login, code, menu_name, is_refresh) {
  let keepAlive = false;
  if (is_refresh == "No") {
    keepAlive = true;
  }
  return {
    path: path,
    component: (r) =>
      require.ensure([], () => r(require("@/views" + path)), "menu"),
    meta: {
      is_login: is_login,
      code: code,
      menu_name: menu_name,
      isUseCache: false, // 这个字段的意思稍后再说
      keepAlive: keepAlive, // 通过此字段判断是否需要缓存当前组件
      scollTopPosition: 0,
    },
  };
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js